export const PAYMENT_AGENT_TYPE = ['Fully', 'NoPay'];
